import React 			from 'react';
import ReactDOM 		from 'react-dom';
import { DateTime } 	from	'luxon'
import Slider from 'react-slick';

import BLComponent		from '../../core/_BLComponent.jsx';

import Pagination from '../../common/_Pagination.jsx';
import CustomCheckbox from '../../common/_CustomCheckbox.jsx';
import CustomRadio from '../../common/_CustomRadio.jsx';
import Preloader from '../../common/_Preloader.jsx';

import BDPSubmissionCard from '../common/_BDPSubmissionCard.jsx';
import SeriesEmptyResults from './_SeriesEmptyResults.jsx';


export default class CrowdSubmissionResults extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
			searchQuery: blapp.util.getUrlVar('s') ? blapp.util.getUrlVar('s') : '',
			resultSearchQuery: blapp.util.getUrlVar('s') ? blapp.util.getUrlVar('s') : '',
			postsPerPage: 24,
			sortMethod: -1,
			sortDirection: 1,
			submissions: [],
			categoryFilter: [],
			filterVoted: 0,
			showFilters: false,
			isLoading: true,
			submissions: null
		}

		this.seriesNumber = parseInt(blapp.util.getUrlInfo(window.location.href).path.split('/')[3].split('-')[1]); 
		this.categories = blapp.models.get('categories') || [];

		this.fetchSubmissions(false);
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevState.submissions == null  && this.state.submissions != null) {
			const submissionsCookie = blapp.cookie.getSessionStorage('bdpSubmissionsId');

			let hasCookieSubmissions;
			let {submissions} = this.state;

			if(submissionsCookie && JSON.parse(submissionsCookie).length == submissions.length && JSON.parse(submissionsCookie).indexOf(submissions[0].idSubmission) != -1) {
				submissions = this.recreateSubmissionsObject(JSON.parse(submissionsCookie), submissions);
				hasCookieSubmissions = true;
			}

			const filters = blapp.cookie.getSessionStorage('bdpFilters') ? JSON.parse(blapp.cookie.getSessionStorage('bdpFilters')) : false;

			if(filters && (filters.categoryFilter && filters.filterVoted != null) && (filters.categoryFilter.length > 0 || filters.filterVoted != 0)){
				this.fetchSubmissions(false)
			}
			else if(filters && filters.sortMethod != -1) {
				this.setState({submissions: submissions, isLoading: false}, () => this.setSubmissions());
				this.setState({postsPerPage: filters.postsPerPage, sortMethod: filters.sortMethod, sortDirection: filters.sortDirection}, () => this.sortResults(false));
			}else{
				if(!hasCookieSubmissions) {
					this.shuffleArray(submissions);
				}

				this.setState({submissions: submissions, isLoading: false, postsPerPage: (filters && filters.postsPerPage ? filters.postsPerPage : 24)}, () => this.setSubmissions());
			}
		}
	}

	recreateSubmissionsObject(idsOrder, submissions) {
		let newSubmissions = []
		idsOrder.forEach(id => {
			newSubmissions.push(submissions.find( s => s.idSubmission == id))
		});

		return newSubmissions;
	}

	render() {
		const {classes} = this.props;

		if(this.state.isLoading) {
			return (
				<div className="l-pad-y--xxl l-flex l-center">
					<Preloader/>
				</div>
			);
		}else{
			const submissions = this.state.submissions;
			const submissionItems = submissions.filter(item => item.strSubmissionName.toLowerCase().indexOf(this.state.resultSearchQuery.toLowerCase()) != -1 || (item.dmUserBuilder && item.dmUserBuilder.dmUser.skUsername.toLowerCase().indexOf(this.state.resultSearchQuery.toLowerCase()) != -1)).map(submission => <BDPSubmissionCard data={submission} key={submission.idSubmission} hasVoting={true} quickViewFunc={this.props.quickViewFunc ? () => this.props.quickViewFunc(submission.idSubmission, submissions) : false} classes="bdp-series-submissions__card"/>);

			return (
				<section className={`bdp-series-submissions l-margin-bottom--xl ${classes}`} id="submissions">
					{this.renderResultsText()}
					{this.renderSearchFilters()}
					{submissions.length ? 
						<Pagination data={{postsPerPage: this.state.postsPerPage, changePageCallback: () => this.onPaginate()}} classes="bdp-series-submissions__pagination" containerClasses="bdp-series-submissions__card-container" shouldScrollTop={false}>
							{submissionItems}
						</Pagination>
					:
						<SeriesEmptyResults/>
					}
				</section>
			);
		}
	}

	renderResultsText() {
		const submissions = this.state.submissions;
		const searchLength = submissions.filter(item => item.strSubmissionName.toLowerCase().indexOf(this.state.resultSearchQuery.toLowerCase()) != -1 || (item.dmUserBuilder && item.dmUserBuilder.dmUser.skUsername.toLowerCase().indexOf(this.state.resultSearchQuery.toLowerCase()) != -1)).length;

		if(this.state.resultSearchQuery) {
			return (
				<p className="studio-gallery__results-count text--small-title">
					{searchLength} results for "<strong data-ts-name="bdp-series-submission__search-value">{this.state.resultSearchQuery}</strong>"
				</p>
			);
		}else{
			return (
				<p className="studio-gallery__results-count text--small-title" data-ts-name="bdp-series-submission__count">
					<strong>{this.state.submissions.length} design{this.state.totalModels != 1 ? 's' : ''}</strong>
				</p>
			);
		}
	}

	renderSearchBar() {
		return (
			<div className="bdp-series-submissions__search">
				<div className="search-lockup search-lockup--bordered search-lockup--thick studio-gallery__search-bar">
					<div className={"search-lockup__input-container"}>
						<button className="search-lockup__btn search-lockup__btn--start" data-ts-name="studio-gallery__search-cta" onClick={() => this.doSearch()}><i className="far fa-search search-lockup__btn-icon"/></button>
						<input type="text" data-ts-name="studio-gallery__search-input" onKeyDown={(e) => this.onKeyDown(e)} className="search-lockup__input l-pad-left--null search-lockup__input--end" placeholder={"Search by design name or designer"} value={this.state.searchQuery} onChange={(e) => this.setState({searchQuery: e.target.value})}/>
						{this.state.searchQuery || this.state.resultSearchQuery ? 
							<button className="btn btn--blank" data-ts-name="studio-gallery__search-clear" onClick={() => this.clearSearch()}>
								<i className="fas fa-times-circle search-lockup__btn--clear"/>
							</button>
						: null}
					</div>
				</div>
			</div>
		);
	}

	renderSearchFilters() {
		return (
			<React.Fragment>
				<div className="studio-gallery__filters bdp-series-submissions__filters">
					{this.renderSearchBar()}
					<div className="bdp-series-submissions__filter-trigger">
						<button className="btn bdp-series-submissions__filter-trigger-btn" onClick={() => this.setState({showFilters: !this.state.showFilters})}><i className={`fa-fw ${this.state.showFilters ? 'far fa-filter-slash' : 'fas fa-filter'} l-margin-right--sm`}/>{this.state.showFilters ? 'Hide ' : 'Show '}filters</button>
					</div>
					<div className="bdp-series-submissions__filter-divider"></div>
					<div className="bdp-series-submissions__filter-item bdp-series-submissions__filter-item--sort">
						<div className="sort-lockup sort-lockup--thick">
							{this.state.sortMethod == -1 ?
								<button className="btn sort-lockup__direction" data-ts-name="bdp-series-submission__filter--random" onClick={() => this.randomizeResults()}><i className={"fa-fw far fa-arrows-rotate"}/></button>
							:
								<button className="btn sort-lockup__direction" data-ts-name="bdp-series-submission__filter--sort-direction" onClick={() => this.setState({sortDirection: this.state.sortDirection == 1 ? 2 : 1}, () => this.sortResults())}><i className={"fa-fw far " + (this.state.sortDirection == 1 ? 'fa-sort-amount-down' : 'fa-sort-amount-up')}/></button>
							}
							<select className="select sort-lockup__select" id="sort-by" value={this.state.sortMethod} onChange={(e) => this.setState({sortMethod: e.target.value}, () => this.sortResults())} data-ts-name="bdp-series-submission__filter--sort">
								<option value={-1}>Sort by: Random</option>
								<option value={1}>Sort by: Designer name</option>
								<option value={2}>Sort by: Design title</option>
								<option value={3}>Sort by: Size</option>
							</select>
						</div>
					</div>
					<div className="bdp-series-submissions__filter-item bdp-series-submissions__filter-item--per-page">
						<select className="select bg-color--white text--tight" id="view-per-page" data-ts-name="bdp-series-submission__filter--publish-time" value={this.state.postsPerPage} onChange={(e) => this.setState({postsPerPage: e.target.value}, () => this.setFilters())}>
							<option value={12}>12 per page</option>
							<option value={24}>24 per page</option>
							<option value={48}>48 per page</option>
							<option value={96}>96 per page</option>
						</select>
					</div>
				</div>
				{this.state.showFilters &&
					<section className="bdp-series-submissions__filters-advanced">
						<strong className="text--small-title l-margin-bottom l-block">Apply filters</strong>
						<div className="bdp-series-submissions__filters-advanced-internal">
							<div className="bdp-series-submissions__filters-advanced-group">
								<strong className="bdp-series-submissions__filters-advanced-group-label l-margin-bottom l-block">Voting</strong>
								<label className="l-flex l-margin-bottom">
									<CustomRadio classes="l-margin-right--sm" isChecked={this.state.filterVoted == 0} onChangeFunc={() => this.changeVoted(0)}/>
									All
								</label>
								<label className="l-flex l-margin-bottom">
									<CustomRadio classes="l-margin-right--sm" isChecked={this.state.filterVoted == 1} onChangeFunc={() => this.changeVoted(1)}/>
									Voted
								</label>
								<label className="l-flex">
									<CustomRadio classes="l-margin-right--sm" isChecked={this.state.filterVoted == 2} onChangeFunc={() => this.changeVoted(2)}/>
									Not voted
								</label>
							</div>
							<div className="bdp-series-submissions__filters-advanced-group">
								<div className="l-flex l-margin-bottom">
									<strong className="bdp-series-submissions__filters-advanced-group-label">Categories</strong>
									{this.state.categoryFilter ? <button className="btn btn--link l-margin-left" onClick={() => this.clearAllCategories()}>Clear all</button> : null}
								</div>
								<div className="bdp-series-submissions__filters-advanced-categories">
									{this.categories.map( c => <label className="l-flex l-center" value={c.idCategory}><CustomCheckbox classes="l-margin-right--sm" isDark isChecked={this.state.categoryFilter.includes(c.idCategory)} onChangeFunc={() => this.toggleCategory(c.idCategory)}/>{c.strName}</label>)}
								</div>
							</div>
						</div>
					</section>
				}
			</React.Fragment>
		);
	}

	changeVoted(val) {
		if(blapp.session.isLoggedIn()) {
			this.setState({filterVoted: val}, () => this.fetchSubmissions(true))
		} else {
			blapp.refs.get( "header" ).showLogin(
				() => {
					if(blapp.session.isLoggedIn()) {
						this.setState({filterVoted: val}, () => this.fetchSubmissions(true))
					}
				}
			);			
		}
	}

	clearAllCategories() {
		this.setState({categoryFilter: []}, () => this.fetchSubmissions(true));
	}

	toggleCategory(id) {
		const newCategoryFilters = this.state.categoryFilter;

		if(newCategoryFilters.includes(id)) {
			newCategoryFilters.splice(newCategoryFilters.indexOf(id), 1);
		}else{
			newCategoryFilters.push(id);
		}

		this.setState({categoryFilter: newCategoryFilters}, () => this.fetchSubmissions(true));
	}

	shuffleArray(array) {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}
	}
	
	randomizeResults() {
		const {submissions} = this.state;

		this.shuffleArray(submissions);

		this.setState({submissions: submissions}, () => this.setSubmissions());
	}

	setFilters() {
		const filters = {
			sortDirection: this.state.sortDirection, 
			sortMethod: this.state.sortMethod, 
			postsPerPage: this.state.postsPerPage,
			categoryFilter: this.state.categoryFilter,
			filterVoted: this.state.filterVoted};
		
		try{
			blapp.cookie.setSessionStorage('bdpFilters', JSON.stringify(filters));
		}catch(err) {
			console.log(err);
		} 
	}

	setSubmissions() {
		const submissions = this.state.submissions;
		const submissionIDs = submissions.map(s => s.idSubmission)
		try{
			blapp.cookie.setSessionStorage('bdpSubmissionsId', JSON.stringify(submissionIDs));
		}catch(err) {
			console.log(err);
		}
	}

	doSearch() {
		this.setState({resultSearchQuery: this.state.searchQuery}, () => {
			const newURL = blapp.util.addParamToUrl('s', this.state.searchQuery, window.location);
			history.pushState('', '', newURL);
		});
	}

	clearSearch() {
		this.setState({searchQuery: '', resultSearchQuery: ''}, () => {
			const newURL = blapp.util.removeParamFromUrl('s', window.location);
			history.pushState('', '', newURL);
		});
	}

	onKeyDown(e) {
		if(e.keyCode == 13) {
			e.preventDefault(); 
			e.stopPropagation(); 
			this.doSearch();
		}
	}

	onPaginate() {
		const container = document.querySelectorAll('.bdp-series-submissions__card-container')[0];
		const containerOffset = container.offsetTop;

		window.scrollTo(0, containerOffset - 100);
	}


	sortResults(triggerSetFilters = true) {
		const {submissions, sortMethod, sortDirection} = this.state;

		const sortedSubmissions = [...submissions];

		sortedSubmissions.sort((submissionA, submissionB) => {
			if(sortMethod == 1) {
				return this.returnSortReturn(submissionA.dmUserBuilder.dmUser.skUsername.toLowerCase(), submissionB.dmUserBuilder.dmUser.skUsername.toLowerCase());
			}else if(sortMethod == 2) {
				return this.returnSortReturn(submissionA.strSubmissionName.toLowerCase(), submissionB.strSubmissionName.toLowerCase());
			}else if(sortMethod == 3) {
				return this.returnSortReturn(submissionA.nTotalParts, submissionB.nTotalParts);
			}
		});
		
		this.setState({submissions: sortedSubmissions});
		
		if(triggerSetFilters) {
			this.setFilters();
		}
	}

	returnSortReturn(itemA, itemB) {
		const {sortDirection} = this.state;

		if(sortDirection == 1) {
			if(itemA < itemB) {
				return -1;
			}
			if(itemA > itemB) {
				return 1;
			}
		}else if(sortDirection == 2) {
			if(itemA > itemB) {
				return -1;
			}
			if(itemA < itemB) {
				return 1;
			}
		}
	}

	fetchSubmissions(saveFilters) {
		this.setState({isLoading: true});

		if(saveFilters == true) {
			this.setFilters();
		}

		const filters = blapp.cookie.getSessionStorage('bdpFilters') ? JSON.parse(blapp.cookie.getSessionStorage('bdpFilters')) : false;
		const f = {
    	categoryFilter: filters ? filters.categoryFilter : this.state.categoryFilter,
    	filterVoted: filters ? filters.filterVoted : this.state.filterVoted,
		}

		blapp.models.fetch(
			"_fetch_submissions"
			, {
				controller: "bdp.BLCBDPSubmission"
				, method: "getBDPSubmissionList"
				, params: [this.seriesNumber, "VALIDATION", false, f]
				, refresh: true
			}
		).then(
			(data) => {
				if(data.errorCode == 'EC_OK'){
					let submissions = data.data.submissions;
					if(filters && filters.sortMethod != -1) {
						this.setState({submissions: submissions}, () => this.setSubmissions());
						this.setState({postsPerPage: filters.postsPerPage, sortMethod: filters.sortMethod, sortDirection: filters.sortDirection,
							categoryFilter: f.categoryFilter, filterVoted: f.filterVoted}, () => this.sortResults(false));
					}else{
						this.shuffleArray(submissions);
						this.setState({submissions: submissions, postsPerPage: (filters && filters.postsPerPage ? filters.postsPerPage : 24),
							categoryFilter: f.categoryFilter, filterVoted: f.filterVoted}, () => this.setSubmissions());
					}
				}
			}
		).catch(
			(err) => {
				console.log(err)
			}
		).finally(
			() => this.setState({isLoading: false})
		);
	}

}